import { render, staticRenderFns } from "./PreorderedMenu.vue?vue&type=template&id=3edb04e0&scoped=true&"
import script from "./PreorderedMenu.vue?vue&type=script&lang=js&"
export * from "./PreorderedMenu.vue?vue&type=script&lang=js&"
import style0 from "./PreorderedMenu.vue?vue&type=style&index=0&id=3edb04e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb04e0",
  null
  
)

export default component.exports